import { useEffect, useState } from "react";//   React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Images
import { useNavigate } from "react-router-dom";
import { Card, Divider, InputLabel } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBadge from "components/MDBadge";

function ViewRatings() {

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Card>
                <MDBox pt={4} pb={3} px={3} >
                    <InputLabel sx={{ fontWeight: 'bold' }} id="Appraisal_Form" mb={2}>View Ratings</InputLabel>
                </MDBox>
                {/* <Divider /> */}

                <MDBox mt={2} mb={4} >
                    <MDBadge component="label" badgeContent="Unable to view details. Please contact HR for further details." color="error" variant="gradient" size="sm" />
                </MDBox>
            </Card>
        </DashboardLayout>
    );
}

export default ViewRatings;
